//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO A FOTO DOS PRODUTOS NAS                //   
//  PÁGINAS DE INTERESSES (FRANQUEADOS) E               //
//  PEDIDOS (FRANQUEADOS E CLIENTES)                    //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR FOTO DOS PRODUTOS           //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////////
//                                                                          //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:        //
//                                                                          //
//      frontend/src/components/preco_picture_franqueado.js                 //
//      frontend/src/components/preco_picture_quantidade_franqueado.js      //
//                                                                          //
//////////////////////////////////////////////////////////////////////////////



import '../assets/css/local/picture.css';

function MockPictureFranqueado(props) {
    return (  //  RENDERIZA O COMPONENTE
        <div class="flip-card mb-4 center">
            <div class="">
                <div class="">
                    <img class='picture' src={props.props.img} alt="Avatar"></img>
                </div>
            </div>
        </div>
    )
}

export default MockPictureFranqueado;